import alt from "../alt";

class SignatureActions {
  fetch() {
    return "nothing";
  }

  fetchUpdated(activity) {
    return activity;
  }
}

export default alt.createActions(SignatureActions);
